import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { Col, Row } from "reactstrap";
import InputComponent from "../../../components/InputComponent";
import { useAvailableModulesContext } from "../../../context/AvailableModulesContext";
import Toast from "../../../helpers/Toast";
import { Utilities } from "../../../helpers/Utilities";
import { AssistanceDTO } from "../../../models/Assistance/AssistanceDTO";
import { AssistanceUpdateDTO } from "../../../models/Assistance/AssistanceUpdateDTO";
import { EquipmentDTO } from "../../../models/Equipment/EquipmentDTO";
import { AssistanceService } from "../../../services/AssistanceService";
import ButtonComponent from "../../ButtonComponent";
import ClientEquipmentBidirecional from "../../ClientEquipmentBidirecional/ClientEquipmentBidirecional";
import SelectComponent from "../../SelectComponent";
import { RenderCountersInputs } from "../RenderCountersInputs";
import { TimeHistoryDTO } from "../../../models/TimeHistory/TimeHistoryDTO";

type AssistanceEditComponentType = {
    assistance: AssistanceDTO;
    isLoadingAssistance: boolean;
    setAssistance: Function;
};

export type SelectItemsProps = {
    label: string;
    value: string;
};

export default function AssistanceEditB({ assistance, isLoadingAssistance, setAssistance }: AssistanceEditComponentType) {
    const [isComplete, setIsComplete] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const assistanceService = new AssistanceService();

    // tipo assistencia
    const [selectedAssistanceType, setSelectedAssistanceType] = useState<string>(Utilities.LoadParameterFromURLQuery("assistanceType", "string", ""));
    const [assistanceTypesComponent, setAssistanceTypesComponent] = useState<SelectItemsProps[]>([]);

    //módulos ativos
    const { availableModules, assistanceTypes, counterOptions } = useAvailableModulesContext();
    const [isActiveCountersModule, setIsActiveCountersModule] = useState<boolean>(false);

    useEffect(() => {
        if (availableModules.includes("IsActiveCountersModule")) {
            setIsActiveCountersModule(true);
        }
    }, [availableModules]);

    //passar dados para inputs dinamicos
    const [timeHistory, setTimeHistory] = useState<TimeHistoryDTO>(assistance.timeHistory || {});
    useEffect(() => {
        if (assistance.timeHistory) {
            setTimeHistory(assistance.timeHistory);
        }
    }, [assistance.timeHistory]);

    // ao atualizar valor dos inputs, levar valor para processo de editar assistência
    useEffect(() => {
        setAssistance((prev: AssistanceDTO) => ({ ...prev, timeHistory }));
    }, [timeHistory]);


    // props para novo componente
    const [isActiveProjectModule, setIsActiveProjectModule] = useState<boolean>(false);
    const [projectSelected, setProjectSelected] = useState<SelectItemsProps | null>(null);
    const [clientSelected, setClientSelected] = useState<SelectItemsProps | null>(null);
    const [serialNumberSelected, setSerialNumberSelected] = useState<SelectItemsProps | null>(null);
    const [equipment, setEquipment] = useState<EquipmentDTO>({} as EquipmentDTO);
    const [isSearchEquipmentLoading, setIsSearchEquipmentLoading] = useState<boolean>(false);
    const [carPlateSelected, setCarPlateSelected] = useState<SelectItemsProps | null>(null);

    //obter tipo de assistencia
    useEffect(() => {
        getAssistanceTypes();
    }, []);
    const getAssistanceTypes = async () => {
        const list: SelectItemsProps[] = [];

        assistanceTypes.forEach((element) => {
            var item: SelectItemsProps = {
                value: element,
                label: element,
            };
            list.push(item);
        });

        setAssistanceTypesComponent(list);
    };

    const EditAssistance = async () => {
        var data: AssistanceUpdateDTO = {
            id: assistance.id,
            date: assistance.date,
            counter1: assistance.timeHistory.counter1 || 0,
            counter2: assistance.timeHistory.counter2 || 0,
            counter3: assistance.timeHistory.counter3 || 0,
            counter4: assistance.timeHistory.counter4 || 0,
            counter5: assistance.timeHistory.counter5 || 0,
            counter6: assistance.timeHistory.counter6 || 0,
            projectErpId: assistance.project?.erpId ?? null,
            clientErpId: assistance.client?.erpId ?? null,
            assistanceType: selectedAssistanceType || assistance.assistanceType,
        };

        setIsLoading(true);
        var response = await assistanceService.Edit(data);
        if (response.success === false) {
            Toast.Show("error", response.message);
            setIsLoading(false);
            return;
        }
        Toast.Show("success", "Assistência editada com sucesso");
        setIsLoading(false);
    };

    useEffect(() => {
        setIsComplete(!assistance.userCanEdit);
    }, [assistance]);

    const intl = useIntl();

    return (
        <>
            <label style={{ margin: "0px", padding: "13px" }}>
                <b>Informação Geral</b>
            </label>

            <Row style={{ margin: "0px", padding: "0px", alignItems: "flex-end", alignContent: "flex-end" }}>
                <SelectComponent
                    xl={4}
                    lg={4}
                    md={4}
                    sm={4}
                    xs={12}
                    style={{ width: "100%", height: "43px" }}
                    label={"Tipo de Assistência"}
                    selectedItemValue={(selectedAssistanceType === null || selectedAssistanceType === "" || selectedAssistanceType === undefined) ? assistance.assistanceType : selectedAssistanceType}
                    items={assistanceTypesComponent}
                    onChange={(t: string) => {
                        setSelectedAssistanceType(t);
                    }}
                    blockItem={isComplete}
                />
            </Row>

            <Row style={{ margin: "0px", padding: "0px", alignItems: "flex-end", alignContent: "flex-end" }}>
                <InputComponent
                    xl={4}
                    lg={4}
                    md={4}
                    sm={4}
                    xs={12}
                    style={{ width: "100%" }}
                    type={"text"}
                    value={assistance?.clientContact ?? null}
                    label={"Contacto do Cliente"}
                    readOnly={isComplete}
                    showLoadingSkeleton={isLoadingAssistance}
                    onChange={(t: string) => {
                        setAssistance({ ...assistance!, clientContact: t });
                    }}
                />
            </Row>
            <Row style={{ margin: "0px", padding: "0px", alignItems: "flex-end", alignContent: "flex-end" }}>
                <ClientEquipmentBidirecional
                    isActiveProjectModule={isActiveProjectModule}
                    projectSelected={projectSelected}
                    clientSelected={clientSelected}
                    setClientSelected={setClientSelected}
                    serialNumberSelected={serialNumberSelected}
                    setSerialNumberSelected={setSerialNumberSelected}
                    equipment={equipment}
                    setEquipment={setEquipment}
                    isSearchEquipmentLoading={isSearchEquipmentLoading}
                    setIsSearchEquipmentLoading={setIsSearchEquipmentLoading}

                    clientErpId={assistance?.client?.erpId}
                    equipmentErpId={assistance?.equipment?.erpId}

                    isActiveSearchByCarPlate={true}
                    carPlateSelected={carPlateSelected}
                    setCarPlateSelected={setCarPlateSelected}

                    isDisabled={true}
                />
            </Row>

            <Row style={{ margin: "0px", padding: "0px", alignItems: "flex-end", alignContent: "flex-end" }}>
                <InputComponent
                    xl={4}
                    lg={4}
                    md={4}
                    sm={4}
                    xs={12}
                    style={{ width: "100%" }}
                    type={"date"}
                    value={assistance?.date != null ? Utilities.formatDateYYYYMMDD(new Date(assistance.date)) : ""}
                    label={"Data"}
                    readOnly={isComplete}
                    showLoadingSkeleton={isLoadingAssistance}
                    onChange={(t: string) => {
                        setAssistance({ ...assistance!, date: new Date(t) });
                    }}
                />

                <InputComponent
                    xl={4}
                    lg={4}
                    md={4}
                    sm={4}
                    xs={12}
                    style={{ width: "100%" }}
                    type={"time"}
                    value={assistance?.date != null ? Utilities.GetTimeFromDateTime(new Date(assistance.date)) : ""}
                    label={"Hora"}
                    readOnly={isComplete}
                    showLoadingSkeleton={isLoadingAssistance}
                    onChange={(t: string) => {
                        setAssistance({
                            ...assistance!,
                            date: new Date(`${Utilities.formatDate(new Date(assistance?.date))}T${t}`),
                        });
                    }}
                />
            </Row>

            {/* Estado 2 - Contadores */}
            {isActiveCountersModule && (
                <>
                    <label style={{ margin: "0px", padding: "13px", fontWeight: "bold" }}>
                        {intl.formatMessage({ id: "Screens.AssistanceEditB.CountersTitle" })}
                    </label>
                    <Row style={{ margin: "0px", padding: "0px" }}>
                        {RenderCountersInputs(counterOptions, timeHistory, setTimeHistory, isComplete)}
                    </Row>
                </>
            )}

            <Row style={{ margin: "0px", padding: "0px" }}>
                <InputComponent
                    xl={12}
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    style={{ width: "100%" }}
                    type={"textArea"}
                    value={assistance?.description}
                    label={"Descrição do Serviço"}
                    readOnly={isComplete}
                    showLoadingSkeleton={isLoadingAssistance}
                    onChange={(t: string) => {
                        setAssistance({ ...assistance!, description: t });
                    }}
                />
            </Row>
            <Row style={{ margin: "0px", padding: "0px" }}>
                <InputComponent
                    xl={12}
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    style={{ width: "100%" }}
                    type={"textArea"}
                    value={assistance?.workDone}
                    label={"Trabalho Efetuado"}
                    readOnly={isComplete}
                    showLoadingSkeleton={isLoadingAssistance}
                    onChange={(t: string) => {
                        setAssistance({ ...assistance!, workDone: t });
                    }}
                />
            </Row>
            <Row style={{ margin: "0px", padding: "0px" }}>
                <InputComponent
                    xl={12}
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    style={{ width: "100%" }}
                    type={"textArea"}
                    value={assistance?.notes}
                    label={"Observações"}
                    readOnly={isComplete}
                    showLoadingSkeleton={isLoadingAssistance}
                    onChange={(t: string) => {
                        setAssistance({ ...assistance!, notes: t });
                    }}
                />
            </Row>
            {isComplete ? (
                ""
            ) : (
                <Row style={{ margin: "0px", padding: "0px", justifyContent: "end" }}>
                    <Col xl={3} lg={3} md={3} sm={12} xs={12}>
                        <ButtonComponent
                            style={{ width: "100%", marginTop: "10px" }}
                            text={intl.formatMessage({ id: "AssistanceEditB.Save" })}
                            onClick={() => EditAssistance()}
                            disabled={isLoading}
                        />
                    </Col>
                </Row>
            )}
        </>
    );
}
